/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { CollectionView } from 'backbone.marionette';

import SideNavContentView from './SideNavContentView';

const SideNavContentCollectionView = CollectionView.extend({
  className: 'side-nav-content-collection-view tab-content',

  childView: SideNavContentView,

  initialize(options) {
    this.activeSectionExists = false;
    if (options.activeSectionId) {
      this.activeSectionExists = Boolean(this.collection.get(options.activeSectionId));
    }
  },

  childViewOptions(model) {
    // Pass the index to the collection view
    let isContentActive;
    if (this.activeSectionExists) {
      isContentActive = model.id === this.options.activeSectionId;
    } else {
      const firstModel = this.collection.at(0);
      isContentActive = firstModel.id === model.id;
    }
    return {
      sideNavView: this.options.sideNavView,
      expanded: this.options.expanded,
      migrated: this.options.migrated,
      isContentActive
    };
  },

  setActiveLinkByIndex(index) {
    _.each(this.children._views, (child, i) => {
      if (i === index) {
        child.makeActive();
        child.reloadData();
      } else {
        child.makeInactive();
      }
    });
  }
});

export default SideNavContentCollectionView;
